import dayjs, { Dayjs } from 'dayjs';

import { SIGNUP_MAXIMUM_AGE, SIGNUP_MINIMUM_AGE } from '@mopla/constants';

export const isBelowMinimumAge = (date: Dayjs): boolean => {
	const today = dayjs().startOf('day');
	const age = today.diff(date, 'year');
	return (
		age < SIGNUP_MINIMUM_AGE ||
		date.add(SIGNUP_MINIMUM_AGE, 'year').isAfter(today)
	);
};

export const isAboveMaximumAge = (date: Dayjs): boolean => {
	const today = dayjs().startOf('day');
	const age = today.diff(date, 'year');
	return (
		age > SIGNUP_MAXIMUM_AGE ||
		date.add(SIGNUP_MAXIMUM_AGE, 'year').isBefore(today)
	);
};
